import { call, put, takeEvery, select } from 'redux-saga/effects';
import * as actionTypes from './actionTypes';
import axios from 'axios';
import { getUserPageRefresh } from '../../baseApp/auth/sagas';

const controllerUrl = '/visitors/';

const searchVisitorCall = searchFields => new Promise((resolve, reject) => {

    if (!axios.defaults.headers.common['Authorization']) {
        axios.get(process.env.REACT_APP_BACKEND_URL + "/auth/read-session").then(response => {
            axios.defaults.headers.common["Authorization"] = "Bearer " + response.data;
            return     axios.get(controllerUrl + 'search', {
                params: {
                    ...searchFields,
                }
            }).then(
                response => resolve(response.data),
                error => reject(error)
            );
        }).catch(e => console.log(e));
    }
    else{
    axios.get(controllerUrl + 'search', {
        params: {
            ...searchFields,
        }
    }).then(
        response => resolve(response.data),
        error => reject(error)
    );
    }
});

const getVisitorCall = visitorId => new Promise((resolve, reject) => {
    axios.get(controllerUrl + visitorId).then(
        response => resolve(response.data),
        error => reject(error)
    );
});

const ediVisitorCall = (visitorId, visitorData) => new Promise((resolve, reject) => {
    axios.put(controllerUrl + visitorId, visitorData).then(
        response => resolve(response.data),
        error => reject(error)
    );
});

function* searchVisitorsRequest({searchFields}) {
    try {
        const userDefined = yield select(state => state.authReducer.user);

        if (!userDefined || !userDefined.role) {
            yield call(getUserPageRefresh);
        }
        else{
            console.log("user already defined", userDefined);
        }
        const searchResults = yield call(() => searchVisitorCall(searchFields));

        yield put({
            type: actionTypes.VISITOR_SEARCH_SUCCESS,
            payload: searchResults
        });
    } catch (e) {
        yield put({
            type: actionTypes.VISITOR_SEARCH_FAILED
        });
    }
}

function* getVisitorRequest({ visitorId }) {
    try {
        const visitor = yield call(getVisitorCall, visitorId);

        yield put({
            type: actionTypes.GET_VISITOR_SUCCESS,
            payload: visitor
        });
    } catch (e) {
    }
}

function* editVisitorRequest({ visitorId, visitorData }) {
    try {
        yield call(ediVisitorCall, visitorId, visitorData);

        yield put({
            type: actionTypes.EDIT_VISITOR_SUCCESS
        })
    } catch (e) {
        yield put({
            type: actionTypes.EDIT_VISITOR_FAILED
        })
    }
}

const visitorsSagas = [
    takeEvery(actionTypes.VISITOR_SEARCH_REQUEST, searchVisitorsRequest),
    takeEvery(actionTypes.GET_VISITOR_REQUEST, getVisitorRequest),
    takeEvery(actionTypes.EDIT_VISITOR_REQUEST, editVisitorRequest),
];

export {
    visitorsSagas,
    getVisitorCall,
};